import React, { useEffect, useState } from "react";

import bnrvid from "../../Assets/images/bnrbg.mp4";
import bnrvidwebm from "../../Assets/images/bnrbg.webm";
import bnrvid2 from "../../Assets/images/bnrbg2.mp4";
import bnrvid2webm from "../../Assets/images/bnrbg2.webm";

import binance from "../../Assets/images/binance-smartchain.webp";
import trustwallet from "../../Assets/images/trustwallet.webp";
import metamask from "../../Assets/images/metamask.webp";
import safepal from "../../Assets/images/safepal.webp";
import toast, { Toaster } from "react-hot-toast";

const texts = ["ExBit", "Crypto", "Exbit", "Future", "Value"];

const notify = () => toast.success("Copied Successfully!");

const Banner = () => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFadingOut(true);
      setTimeout(() => {
        setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
        setIsFadingOut(false);
      }, 500);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section className="relative mb-30 pt-16 sm:pt-28 md:pt-24 min-h-[80vh] sm:min-h-[85vh] ">
        <div
          className="absolute block top-[76%] sm:top-[65%]  md:top-2/4 left-2/4  object-cover w-full -z-10 "
          style={{ transform: "translate(-50%, -50%)" }}
        >
          <video
            muted
            autoPlay
            playsInline
            loop
            className="w-full h-full hidden md:block opacity-100 "
          >
            <source src={bnrvid} type="video/mp4" />
            <source src={bnrvidwebm} type="video/webm" />
            Your browser does not support the video tag.
          </video>
          <video
            muted
            autoPlay
            playsInline
            loop
            className="w-full h-full block md:hidden opacity-70"
          >
            <source src={bnrvid2} type="video/mp4" />
            <source src={bnrvid2webm} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-y-8">
            <div className="w-full text-center mx-auto">
              <div className="infobox justify-center flex flex-col items-center max-w-7xl mx-auto">
                <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold mb-2">
                  <span
                    className={`text-gradient   bg-gradient-to-br from-yellow-500 via-blue-500 to-blue-400 inline-block text-transparent bg-clip-text  transition-opacity duration-500 ${
                      isFadingOut ? "opacity-0" : "opacity-100"
                    }`}
                  >
                    {texts[currentTextIndex]}
                  </span>{" "}
                  The Next Evolution in Blockchain Finance and Gaming
                </h1>
                <p className="mb-0 mt-3 max-w-3xl font-normal leading-relaxed text-justify sm:text-center">
                  Join the next generation of digital assets, Liquidity farming,
                  and Blockchain gaming. Explore limitless possibilities on the
                  Binance Smart Chain.
                </p>
                <div className="flex flex-wrap gap-4 mt-5">
                  <div className="bnrbtn transition-all duration-300 relative ease-in-out transform hover:scale-105">
                    <a
                      href="https://docs.ex-bit.ai/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-32 flex justify-center px-2 py-3 relative border-white rounded-lg bg-gradient-to-b from-blue-500 to-custom-dark-end hover:from-blue-600 hover:to-custom-dark-end"
                    >
                      Whitepaper
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className=" pt-16 pb-10 ">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="mb-4 text-center flex flex-col">
            <span className="py-2 px-2 span-bx rounded-full text-md font-medium text-[#ffe400ba] text-center w-28 mx-auto">
              Ecosystem
            </span>
            <h2 className="text-4xl text-center font-bold  bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400 inline-block text-transparent bg-clip-text leading-[3rem] mb-4 ">
              Explore the ExBit Ecosystem
            </h2>
            <p className="text-base font-normal text-gray-400 mb-6">
              Discover the interconnected features that power the Exbit
              platform:
            </p>
          </div>
          <div className="flex flex-wrap gap-4 mx-auto justify-center mb-8">
            <div className="bnrbtn transition-all duration-300 relative ease-in-out transform hover:scale-105">
              <a
                href="https://swap.ex-bit.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-28 flex justify-center px-2 py-3 relative border-white rounded-lg bg-gradient-to-b from-blue-500 to-custom-dark-end hover:from-blue-600 hover:to-custom-dark-end"
              >
                Swap
              </a>
            </div>
            <div className="bnrbtn transition-all duration-300 relative ease-in-out transform hover:scale-105">
              <a
                href="https://stake.ex-bit.ai/login"
                target="_blank"
                rel="noopener noreferrer"
                className="w-28 flex justify-center px-2 py-3 relative border-white rounded-lg bg-gradient-to-b from-blue-500 to-custom-dark-end hover:from-blue-600 hover:to-custom-dark-end"
              >
                Staking
              </a>
            </div>

            <div className="bnrbtn transition-all duration-300 relative ease-in-out transform hover:scale-105">
              <a
                href="https://games.ex-bit.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-28 flex justify-center px-2 py-3 relative border-white rounded-lg bg-gradient-to-b from-blue-500 to-custom-dark-end hover:from-blue-600 hover:to-custom-dark-end"
              >
                Games
              </a>
            </div>
            <div className="bnrbtn transition-all duration-300 relative ease-in-out transform hover:scale-105">
              <a
                href="https://dex.ex-bit.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-28 flex justify-center px-2 py-3 relative border-white rounded-lg bg-gradient-to-b from-blue-500 to-custom-dark-end hover:from-blue-600 hover:to-custom-dark-end"
              >
                Dex
              </a>
            </div>

            {/* <div className="bnrbtn transition-all duration-300 relative ease-in-out transform hover:scale-105">
    <a
      href="https://dex.ex-bit.ai/" 
      target="_blank"
      rel="noopener noreferrer"
      className="w-28 flex justify-center px-2 py-3 relative border-white rounded-lg bg-gradient-to-b from-blue-500 to-custom-dark-end hover:from-blue-600 hover:to-custom-dark-end"
    >
      Farming
    </a>
  </div> */}
            <div className="bnrbtn transition-all duration-300 relative ease-in-out transform hover:scale-105">
              <a
                href="https://wallet.ex-bit.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-28 flex justify-center px-2 py-3 relative border-white rounded-lg bg-gradient-to-b from-blue-500 to-custom-dark-end hover:from-blue-600 hover:to-custom-dark-end"
              >
                Wallet
              </a>
            </div>
          </div>

          <p className="text-base font-normal text-gray-400 mb-12 text-center">
            Every element of the Exbit ecosystem is designed to provide a
            user-friendly and rewarding journey.
          </p>
          <div className="flex justify-center items-center flex-wrap max-w-4xl mx-auto">
            <div className="relative w-1/2 text-center max-md:max-w-sm max-md:mx-auto group   sm:w-1/4">
              <div className=" p-2 ecosystem-bg  ecosystemcard-1 rounded-lg flex justify-center items-center mb-5 w-24 h-24 mx-auto cursor-pointer transition-all duration-500 group-hover:bg-yellow-500">
                <img
                  src={binance}
                  height={100}
                  width={100}
                  alt="logo"
                  className="block w-18 h-auto"
                />
              </div>
              <h3 className="text-lg font-medium text-gray-400 mb-3 capitalize !leading-5">
                Binance Smart Chain
              </h3>
            </div>
            <div className="relative w-1/2 text-center max-md:max-w-sm max-md:mx-auto group  sm:w-1/4">
              <div className=" p-2 ecosystem-bg ecosystemcard-2  rounded-lg flex justify-center items-center mb-5 w-24 h-24 mx-auto cursor-pointer transition-all duration-500 group-hover:bg-amber-600">
                <img
                  src={metamask}
                  height={100}
                  width={100}
                  alt="logo"
                  className="block w-18 h-auto"
                />
              </div>
              <h3 className="text-lg font-medium text-gray-400 mb-3 capitalize">
                MetaMask
              </h3>
            </div>
            <div className="relative w-1/2 text-center max-md:max-w-sm max-md:mx-auto group  sm:w-1/4">
              <div className=" p-2 ecosystem-bg ecosystemcard-1  rounded-lg flex justify-center items-center mb-5 w-24 h-24 mx-auto cursor-pointer transition-all duration-500 group-hover:bg-blue-500">
                <img
                  src={trustwallet}
                  height={100}
                  width={100}
                  alt="logo"
                  className="block w-18 h-auto"
                />
              </div>
              <h3 className="text-lg font-medium text-gray-400 mb-3 capitalize">
                TrustWallet
              </h3>
            </div>
            <div className="relative w-1/2 text-center max-md:max-w-sm max-md:mx-auto group  sm:w-1/4">
              <div className="p-2 ecosystem-bg ecosystemcard-1  rounded-lg flex justify-center items-center mb-5 w-24 h-24 mx-auto cursor-pointer transition-all duration-500 group-hover:bg-violet-600">
                <img
                  src={safepal}
                  height={100}
                  width={100}
                  alt="logo"
                  className="block w-18 h-auto"
                />
              </div>
              <h3 className="text-lg font-medium text-gray-400 mb-3 capitalize">
                SafePal
              </h3>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
